export default "__VITE_ASSET__BMALw6NZ__"